import React, { useState } from 'react';
import ClickOut from 'react-click-out';
import _ from 'lodash';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import {
  IOilFilter,
  IProductCategory,
  IProductRecommendation,
  IState,
  Replacement,
} from '../../interface';
import publicImage from '../../utils/publicImage';
import localesReplacement from '../../utils/localesReplacement';
import { connect } from 'react-redux';

const cx = classnames.bind(style);

export interface IProps extends IOilFilter {
  dataList: IProductCategory[] | IProductRecommendation[];
  type: string;
  replacements: Replacement;
  onChangeHandler: (value: IProductCategory | IProductRecommendation) => void;
}

//product categories & product recommendations dropdown component
export const OilSelection = (props: IProps) => {
  const { type, replacements, onChangeHandler } = props;
  let { dataList } = props;
  const ingoredElements = ['Bike', 'Car', 'Truck', 'Edge', 'GTX', 'Magnatec'];
  // TODO Temp fix to exclude exclude ingoredElements from product categories dropdown from recommendations page
  // INFUTURE  Handle this from the data in ProductCategories table
  if (dataList) {
    dataList = dataList.filter(x => !ingoredElements.includes(x.name));
  }
  const [visible, setVisible] = useState<boolean>(false);
  //Change innput files handler
  const changeHandler = (value: IProductCategory | IProductRecommendation) => {
    value['checked'] = !value['checked'];
    onChangeHandler(value);
  };
  return (
    <div className={cx('oil-selection', { open: visible })}>
      <ClickOut className='click-out' onClickOut={() => setVisible(false)}>
        {/** Selected text for dropdown */}
        <div className={cx('dropdown')} onClick={() => setVisible(!visible)}>
          {_.isEqual(type, 'category') && (
            <>
              <strong>
                {localesReplacement(replacements, 'Product Categories')}
              </strong>
              <span className='overflowText'>
                {!_.isEmpty(_.chain(dataList).filter('checked').value())
                  ? _.chain(dataList)
                    .filter('checked')
                    .map((d) => localesReplacement(replacements, d['name']))
                    .join(' , ')
                    .value()
                  : localesReplacement(
                    replacements,
                    'Filter by product categories',
                  )}
              </span>
            </>
          )}
          {_.isEqual(type, 'recommendations') && (
            <>
              <strong>
                {localesReplacement(replacements, 'Recommended Lubricants')}
              </strong>
              <span className='overflowText'>
                {!_.isEmpty(_.chain(dataList).filter('checked').value())
                  ? _.chain(dataList)
                    .filter('checked')
                    .map((d) => d['value'])
                    .join(' , ')
                    .value()
                  : localesReplacement(
                    replacements,
                    'Filter by our recommedations',
                  )}
              </span>
            </>
          )}
        </div>
        {/** Flyout for dropdown */}
        <ul>
          {_.map(dataList, (o, i) => (
            <li key={i}>
              <label className='custom-checkbox'>
                <input
                  type='checkbox'
                  value={o['name']}
                  checked={o['checked']}
                  onChange={() => changeHandler(o)}
                />
                <span className='checkbox'></span>
                <img src={publicImage(o['name'] ? `categories/${o['name']}.jpg` : 'oil-01.png')} alt={o['name']} />
                {localesReplacement(replacements, o['name'])}
              </label>
            </li>
          ))}
        </ul>
      </ClickOut>
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
});

export default connect(mapStateToProps)(OilSelection);
